<template>
  <div class="form-box" :style="[backgroundColor]">
    <div class="is-form" :style="[bodyStyle]">
      <div v-if="list && list.length" class="is-form-info">
        <div class="is-form-info-row" v-for="(item, index) in list" :key="index">
          <div v-if="item.contentType * 1 !== 11" class="is-form-title font-15" :class="[item.required ? 'red_star' : '' , fontSizeNum ? 'BIG_title' : '' ]">{{ item.title }}</div>
          <span v-if="item.explains" :class="[fontSizeNum ? 'BIG_explains' : '' ]" class="is-form-explains font-12 color-666">{{ item.explains }}</span>
          <!-- 手机号 -->
          <van-field
            v-if="item.contentType * 1 === 6"
            v-model="item.value"
            type="tel"
            :placeholder="item.tip || '请输入'"
            maxlength="11"
            :class="[fontSizeNum ? 'BIG_input' : '' ]"
            class="is-form-sj is-form-ipt"
          />
          <!-- 单行文本 -->
          <van-field
            v-else-if="item.contentType * 1 === 5"
            v-model="item.value"
            type="text"
            :placeholder="item.tip || '请输入'"
            :class="[fontSizeNum ? 'BIG_input' : '' ]"
            class="is-form-sj is-form-ipt"
          />
          <!-- 多行文本 -->
          <van-field
            v-else-if="item.contentType * 1 === 2"
            v-model="item.value"
            type="textarea"
            rows="2"
            autosize
            :placeholder="item.tip || '请输入'"
            :class="[fontSizeNum ? 'BIG_input' : '' ]"
            class="is-form-sj is-form-iptarea"
          />
          <!-- 日期 -->
          <div v-else-if="item.contentType * 1 === 3"  class="is-form-sj">
            <div
              class="picker is-form-ipt position-relation"
              :class="[fontSizeNum ? 'BIG_timeAddInput' : '' ]"
              @click="handleDate(item, index)"
            >
              <span :style="{ color: item.value ? '#323233' : 'rgb(150, 151, 153, 0.5)' }">{{ item.value || item.tip || '请选择日期' }}</span>
              <van-icon name="notes-o" class="add-right-icon" />
            </div>
          </div>
          <!-- 地区 -->
          <div v-else-if="item.contentType * 1 === 4" class="is-form-sj">
            <div
              class="picker is-form-ipt position-relation"
              :class="[fontSizeNum ? 'BIG_timeAddInput' : '' ]"
              @click="handleAddress(item, index)"
            >
              <span :style="{ color: item.value ? '#323233' : 'rgb(150, 151, 153, 0.5)' }">{{ item.value || item.tip || '请选择地区' }}</span>
              <van-icon name="location-o" class="add-right-icon" />
            </div>
          </div>
          <!-- 图片 -->
          <div v-else-if="item.contentType * 1 === 1" class="is-form-sj">
            <van-uploader
              v-model="item.value"
              multiple
              :max-count="item.defaultData && item.defaultData.num * 1"
              :after-read="afterRead"
              :before-read="beforeRead"
            />
          </div>
          <!-- 单选 -->
          <div v-else-if="item.contentType * 1 === 7" class="is-form-sj">
            <van-radio-group v-model="item.value">
              <van-radio v-for="(i, j) in item.defaultData.radioArr" :key="j" :name="j" style="margin-bottom: 5px">{{ i }}</van-radio>
              <van-radio v-if="item.defaultData.isOther" :name="-1">其他</van-radio>
            </van-radio-group>
            <van-field
              v-if="-1 === item.value"
              v-model="item.otherValue"
              type="textarea"
              rows="1"
              autosize
              style="border-bottom: 1px solid #DCDFE6;"
            />
          </div>
          <!-- 多选 -->
          <div v-else-if="item.contentType * 1 === 8" class="is-form-sj">
            <van-checkbox-group v-model="item.value">
              <van-checkbox v-for="(i, j) in item.defaultData.checkboxArr" :key="j" :name="j" style="margin-bottom: 5px">{{ i }}</van-checkbox>
              <van-checkbox v-if="item.defaultData.isOther" :name="-1">其他</van-checkbox>
            </van-checkbox-group>
            <van-field
              v-if="item.value.includes(-1)"
              v-model="item.otherValue"
              type="textarea"
              rows="1"
              autosize
              style="border-bottom: 1px solid #DCDFE6;"
            />
          </div>
          <!-- 下拉框 -->
          <div v-else-if="item.contentType * 1 === 9" class="is-form-sj">
            <select v-model="item.value" class="is-form-ipt" style="width: 100%;">
              <option disabled value="">请选择</option>
              <option v-for="(i, j) in item.defaultData.dropdownArr" :key="j" :value="j">{{ i }}</option>
            </select>
          </div>
          <!-- 评分 -->
          <div v-else-if="item.contentType * 1 === 10" class="is-form-sj">
            <van-rate v-model="item.value" :color="facade.grade_bgcolor" :count="item.defaultData.gradeValue" :void-icon="unselectedIcon(item.defaultData.selectIcon)" :icon="selectedIcon(item.defaultData.selectIcon)" :icon-prefix="prefixIcon(item.defaultData.selectIcon)" />
            <span style="margin-left: 5px;">{{ item.defaultData.markList[item.value - 1] || '' }}</span>
          </div>
          <!-- 标题 -->
          <div v-else-if="item.contentType * 1 === 11" class="list-title-block">
            <div v-if="item.defaultData.name" :class="[fontSizeNum ? 'BIG_title' : '' ]" class="list-title">{{ item.defaultData.name }}</div>
            <div v-if="item.defaultData.funame" :class="[fontSizeNum ? 'BIG_explains' : '' ]" class="list-funame">{{ item.defaultData.funame }}</div>
          </div>
          <!-- 填写不符合规范 -->
					<span v-if="item.showErr" :class="[fontSizeNum ? 'BIG_explains' : '' ]" class="inline-block font-12 color-red is-form-sj">{{ item.error }}</span>
        </div>
      </div>
      <div class="is-form-btn" :style="[btnStyle]" @click="submit">{{ content.form.commitText }}</div>

      <!-- 日期选择弹窗 -->
      <van-popup v-model="dateShow" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="请选择日期"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="dateConfirm"
          @cancel="dateShow = false"
        />
      </van-popup>

      <!-- 地址选择弹窗 -->
      <van-popup v-model="addressShow" position="bottom">
        <van-area
          title="请选择地区"
          :value="addressValue"
          :area-list="areaList"
          @cancel="addressShow = false"
          @confirm="addressConfirm"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import axios from 'axios';
import { developer } from '@/utils/env.js';
import { Toast } from 'vant';

export default {
  data() {
    return {
      selectDate: '',
      addressInfo: {
        provinceName: '',
        cityName: '',
        countyName: ''
      },
      list: [],
      fontSizeNum:0,
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
      currentIndex: 0,
      dateShow: false,
      areaList: areaList,
      addressShow: false,
      addressValue: ''
    }
  },
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    }
  },
  watch: {
    content: {
      deep: true,
      immediate: true,
      handler(val) {
        let list = (val && val.form && val.form.list) || []
        this.list = JSON.parse(JSON.stringify(list))
        this.fontSizeNum = this.content.form.fontSize;
        this.initialDate()
        console.log(this.list, this.facade, this.content.form, '表单组件=====')
        console.log(this.facade.grade_bgcolor, '表单组件22=====')
      }
    }
  },
  computed: {
    backgroundColor() {
      return {
        paddingLeft: this.facade.leftRightMargins + "px",
        paddingRight: this.facade.leftRightMargins + "px"
      };
    },
    bodyStyle() {
      return {
        backgroundColor: this.facade.background_color,
        borderRadius: this.facade.background_radius + "px",
        color: this.facade.title_color,
      }
    },
    btnStyle() {
      return {
        backgroundColor: this.facade.btn_bgcolor,
        borderRadius: this.facade.btn_radius + "px",
        height: this.facade.btn_height + "px",
        lineHeight: this.facade.btn_height + "px",
        gradeColor: this.facade.grade_bgcolor
      }
    },
  },
  methods: {
    initialDate() {
      let now = new Date()
      let year = now.getFullYear();
      let month = now.getMonth();
      let day = now.getDate();
      this.currentDate = new Date(year, month, day)
      this.minDate = new Date(year - 100, 0, 1)
      this.maxDate = new Date(year + 100, 11, 31)
    },
    dateConfirm(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1 < 10 ? `0${e.getMonth() + 1}` : e.getMonth() + 1;
      let day = e.getDate() < 10 ? `0${e.getDate()}` : e.getDate();
      this.list[this.currentIndex].value = `${year}-${month}-${day}`
      // console.log(this.list)
      this.dateShow = false
    },
    handleDate(item, index) {
      this.currentIndex = index
      let now = ''
      if (item.value) {
        now = new Date(item.value)
      } else {
        now = new Date()
      }
      let year = now.getFullYear();
      let month = now.getMonth();
      let day = now.getDate();
      this.currentDate = new Date(year, month, day)
      this.dateShow = true
    },
    addressConfirm(e) {
      let str = e.map((option) => option.name).join(',')
      this.list[this.currentIndex].value = str
      this.list[this.currentIndex].selectValue = e[2].code
      this.addressShow = false
    },
    handleAddress(item, index) {
      this.currentIndex = index
      if (item && item.selectValue) {
        this.addressValue = item.selectValue
      } else {
        this.addressValue = ''
      }
      this.addressShow = true
    },
    afterRead(file) {
      console.log(file, 'afterRead');
      if (file.constructor == Object) {
        console.log('对象类型')
        file.status = 'uploading'
        file.message = '上传中...'
        this.uploadPic(file).then(res => {
          if (res && res.status === '00000' && res.message) {
            file.status = ''
            file.message = ''
            file.url = res.message
            console.log(this.list)
          } else {
            file.status = 'failed';
            file.message = '上传失败';
          }
        }).catch(() => {
          file.status = 'failed';
          file.message = '上传失败';
        })
      } else if (file.constructor == Array) {
        console.log('数组类型')
        if (file && file.length) {
          file.forEach(item => {
            item.status = 'uploading'
            item.message = '上传中...'
            this.uploadPic(item).then(res => {
              if (res && res.status === '00000' && res.message) {
                item.status = ''
                item.message = ''
                item.url = res.message
                console.log(this.list)
              } else {
                item.status = 'failed';
                item.message = '上传失败';
              }
            }).catch(() => {
              item.status = 'failed';
              item.message = '上传失败';
            })
          })
        }
      }
    },
    uploadPic(file) {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("file", file.file);
        axios.post(`https://${developer}.zkqsxt.com/auth/api/file/uploadFile`, formData)
        .then((res) => {
          console.log(res, '上传图片返回')
          resolve(res.data)
        })
        .catch((err) => {
          console.log(err, '上传图片报错')
          reject(err)
        })
      })
    },
    beforeRead(file) {
      console.log(file, 'beforeRead')
      if (file.constructor == File) {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          Toast('请上传JPG或PNG格式的图片');
          return false;
        }
        if (file.size > 1048576) {
          Toast('图片大小不能超过1MB');
          return false;
        }
        return true;
      } else if (file.constructor == Array) {
        if (file && file.length) {
          for (let i = 0; i < file.length; i++) {
            if (file[i].type !== 'image/jpeg' && file[i].type !== 'image/png') {
              Toast('请上传JPG或PNG格式的图片');
              return false;
            }
            if (file[i].size > 1048576) {
              Toast('图片大小不能超过1MB');
              return false;
            }
          }
          return true;
        }
      }
    },
    unselectedIcon(num) {
      if (num == 1) {
        return 'like-o'
      } else if (num == 2) {
        return 'thumbup'
      } else if (num == 3) {
        return 'star-o'
      }
    },
    selectedIcon(num) {
      if (num == 1) {
        return 'like'
      } else if (num == 2) {
        return 'thumbup-fill'
      } else if (num == 3) {
        return 'star'
      }
    },
    prefixIcon(num) {
      if (num == 1) {
        return 'van-icon'
      } else if (num == 2) {
        return 'icon'
      } else if (num == 3) {
        return 'van-icon'
      }
    },
    submit() {
      console.log('提交表单', this.list)
      let list = []
      let errNub = 0
      if (this.list && this.list.length) {
        this.list.forEach(item => {
          item.showErr = false
          item.error = `请填写${item.title}`
          if (item.contentType * 1 === 7 || item.contentType * 1 === 8 || item.contentType * 1 === 9) {
            item.error = `请选择${item.title}`
          }
          if (item.contentType * 1 === 1) {
            item.error = `请上传${item.title}`
          }
          if (item.contentType * 1 === 10) {
            item.error = `请评分`
          }

          if (item.required && item.contentType * 1 !== 11) {
            if (item.value.constructor == String) {
              if (item.value === '') {
                item.showErr = true
                errNub ++
              }
            }
            if (item.value.constructor == Number) {
              if (item.value < -1) {
                item.showErr = true
                errNub ++
              }
            }
            if (item.value.constructor == Array) {
              if (!item.value.length) {
                item.showErr = true
                errNub ++
              }
            }
          }
          if (item.required && item.contentType * 1 === 6 && !/^1[3456789]\d{9}$/.test(item.value)) {
            item.error = `请填写正确的${item.title}`
            item.showErr = true
            errNub ++
          }
          if (item.contentType * 1 === 7 && item.value.constructor == Number) {
            if (item.value === -1 && item.otherValue === '') {
              item.error = `请填写其他`
              item.showErr = true
              errNub ++
            }
          }
          if (item.contentType * 1 === 8 && item.value.constructor == Array) {
            if (item.value.includes('-1') && item.otherValue === '') {
              item.error = `请填写其他`
              item.showErr = true
              errNub ++
            }
          }
          if (item.required && item.contentType * 1 === 10 && item.value == 0) {
            item.showErr = true
            errNub ++
          }
        })
        console.log('errNub', errNub)
        this.$forceUpdate()

        if (!errNub) {
          list = this.list.map(item => {
            if (item.contentType * 1 === 7 && item.value.constructor == Number) {
              let str = ''
              if (item.value == -1) {
                str = `其他：${item.otherValue}`
              } else {
                str = item.defaultData.radioArr[item.value]
              }
              return {
                contentId: item.id,
                data: str
              }
            } else if (item.contentType * 1 === 8 && item.value.constructor == Array) {
              let arr = []
              if (item.value.length) {
                let newArr = JSON.parse(JSON.stringify(item.value))
                let canDel = newArr.includes('-1')
                if (canDel) {
                  let index = newArr.indexOf('-1')
                  newArr.splice(index, 1)
                }
                if (newArr.length >= 2) {
                  for (let i = 0; i < newArr.length; i++) {
                    for (let j = 0; j < newArr.length - i; j++) {
                      if(newArr[j] > newArr[j + 1]) {
                        // 交换两个数的位置
                        let temp = 0;
                        temp = newArr[j];
                        newArr[j] = newArr[j + 1];
                        newArr[j + 1] = temp;
                      }
                    }
                  }
                }
                if (canDel) {
                  newArr.push('-1')
                }
                newArr.forEach(i => {
                  if (i != '-1') {
                    arr.push(item.defaultData.checkboxArr[i])
                  } else {
                    arr.push(`其他：${item.otherValue}`)
                  }
                })
              }
              return {
                contentId: item.id,
                data: arr.toString(),
                originalData: JSON.stringify(arr)
              }
            } else if (item.contentType * 1 === 9 && item.value.constructor == Number) {
              return {
                contentId: item.id,
                data: item.defaultData.dropdownArr[item.value]
              }
            } else if (item.contentType * 1 === 10 && item.value.constructor == Number && item.value !== 0) {
              return {
                contentId: item.id,
                data: `${item.value}颗星，${item.defaultData.markList[item.value - 1]}`,
                originalData: `${item.value}`
              }
            } else if (item.contentType * 1 === 11) {
              let str = ''
              if (item.defaultData.name && item.defaultData.funame) {
                str = `${item.defaultData.name}(${item.defaultData.funame})`
              } else if (item.defaultData.name) {
                str = item.defaultData.name
              } else if (item.defaultData.funame) {
                str = item.defaultData.funame
              }
              return {
                contentId: item.id,
                data: str
              }
            } else if (item.contentType * 1 === 1 && item.value.constructor == Array && item.value.length) {
              let arr = []
              item.value.forEach(item => {
                arr.push(item.url)
              })
              return {
                contentId: item.id,
                data: arr.toString()
              }
            } else {
              return Object.assign({}, {contentId: item.id, data: item.value ? item.value.toString() : ''})
            }
          })
          this.submitRequest(list)
        } else {
          Toast('请按要求填写！');
        }
      } else {
        this.submitRequest()
      }
    },
    submitRequest(list) {
      let params = {
        formId: this.content.formId,
        formName: this.content.form && this.content.form.formName,
        shopTel: this.content.form && this.content.form.shopTel || ''
      }
      if (list && list.length) params.formContentApplies = list
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '提交中...',
        loadingType: 'spinner',
      });
      this.$store.dispatch('POST_H5FORM_CREATE', params).then(res => {
        console.log(res, '提交表单结果')
        Toast.clear();
        if (res && res.status === '00000') {
          Toast.success('提交成功')
        } else {
          Toast.fail(res.message || '提交失败')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.color-red {
  color: #BF1A20;
}

.inline-block {
  display: inline-block;
}

.picker {
  font-size: 14px;
}

.font-15 {
  font-size: 15px;
}

.font-12 {
  font-size: 12px
}

.color-666 {
  color: #666;
}

.opacity-6{
  opacity: 0.6;
}

.add-right-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.position-relation{
  position: relative;
}

.is-form-iptarea{
  width: 100%;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  color: #606266;
  padding: 8px 15px;
  line-height: 1.5;
  min-height: 64px;
}

.is-form-ipt {
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  color: #606266;
  padding: 0 15px;
}

.form-box {
  width: 100%;

  .is-form {
    padding: 10px;

    &-info {
      margin-bottom: 15px;

      &-row {
        margin: 25px 0;
      }
    }

    &-title {
      padding-left: 14px;
    }

    &-explains {
      padding-left: 14px;
    }

    &-sj {
      margin-top: 8px;
    }

    &-btn {
      /* width: 100%; */
      height: 38px;
      line-height: 38px;
      border-radius: 8px;
      color: white;
      background-color: #e60b30;
      font-size: 15px;
      font-weight: 500;
      text-align: center;
      padding: 0 10px;
    }
  }
}
	
.list-title-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; 
}

.list-title {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
}
	
.list-funame {
  color: #999999;
  font-size: 14px;
  margin-top: 10px;
}

// 字体放大 
.BIG_title{
  // 导航标题
  font-size: 25px;
}

.BIG_explains{
  // 副标题
  font-size: 20px;
}

.BIG_input{
  // 单输入框
  font-size: 20px;
  height: 42px;
  line-height: 42px;
}

.BIG_textarea{
  // 多行文本
  font-size: 20px;
  min-height: 100px;
}

.BIG_timeAddInput{
  // 时间 地区
  height: 40px;
  line-height: 40px;
  font-size: 20px;
}

.BIG_radio{
  font-size: 20px;
}

.BIG_transform{
  transform: scale(0.5);
}

.red_star {
  position: relative;
}

.red_star::after {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  background: url('https://zk-micro.oss-cn-hangzhou.aliyuncs.com/red_star.png') no-repeat;
  background-size: 10px 10px;
}
</style>